var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.818 26H7.182C6.652 26 6 25.46 6 24.5v-15C6 8.54 6.653 8 7.182 8h19.636C27.348 8 28 8.54 28 9.5v15c0 .96-.653 1.5-1.182 1.5z",
    stroke: "#000",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14l4.586 4.586a2 2 0 002.828 0L23 14M11 20l3-3m9 3l-3-3",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAzNCAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjM0IiBoZWlnaHQ9IjM0IiByeD0iNCIgZmlsbD0iI0YyRjJGMiIvPgo8cGF0aCBmaWxsPSJub25lIiBkPSJNMjYuODE4MiAyNkg3LjE4MTgyQzYuNjUyNjMgMjYgNiAyNS40NjA2IDYgMjQuNVYxOC4yNVYxNS43NVY5LjVDNiA4LjUzOTM4IDYuNjUyNjMgOCA3LjE4MTgyIDhIMjYuODE4MkMyNy4zNDc0IDggMjggOC41MzkzOCAyOCA5LjVWMTUuNzVWMTguMjVWMjQuNUMyOCAyNS40NjA2IDI3LjM0NzQgMjYgMjYuODE4MiAyNloiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBmaWxsPSJub25lIiBkPSJNMTEgMTRMMTUuNTg1OCAxOC41ODU4QzE2LjM2NjggMTkuMzY2OCAxNy42MzMyIDE5LjM2NjggMTguNDE0MiAxOC41ODU4TDIzIDE0IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBmaWxsPSJub25lIiBkPSJNMTEgMjBMMTQgMTdNMjMgMjBMMjAgMTciIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgMail as ReactComponent };